import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@/types/user';
import { UserPreferences } from '@/types/user-preferences';
import { tokenStorage, refreshTokenStorage } from '@/utils/storage-keys';

interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    clearUser: () => {
      // Clear tokens from storage
      tokenStorage.remove();
      refreshTokenStorage.remove();
      localStorage.clear();
      return initialState;
    },
    setUserPreferences: (state, action: PayloadAction<UserPreferences>) => {
      if (state.user) {
        state.user.preferences = { ...state.user.preferences, ...action.payload };
      }
    },
  },
});

export const { setUser, clearUser, setUserPreferences } = userSlice.actions;
export default userSlice.reducer;
